import { z } from "zod";

const selectedCartonStatuses = [
	"Processing",
	"Waiting",
	"Dispatched",
	"Produced",
	"Retracting",
	"Failed",
	"Unknown",
] as const;
export const selectedCartonStatusSchema = z.enum(selectedCartonStatuses);
export type SelectedCarton = z.infer<typeof selectedCartonSchema>;

export const selectedCartonSchema = z.object({
	id: z.string(),
	solutionAlias: z.string(),
	componentAlias: z.string().nullish(),
	status: selectedCartonStatusSchema,
	machineAliases: z.array(z.string()),
	type: z.string(),
	lastUpdatedUTC: z.coerce.date(),
});
